import { createFileRoute, redirect } from "@tanstack/react-router";

// Backward-compat redirect — preserves the $id param so deep-links land on
// the correct editor under the new /prompt-engine/templates/$id path.
export const Route = createFileRoute("/_admin/prompt-templates/$id")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/prompt-engine/templates/$id",
      params: { id: params.id },
      replace: true,
    });
  },
  component: () => null,
});
